import styled from "styled-components";

export const Section = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${({theme}) => theme.v2.spacing(4)} 0;
  > *:not(:last-child) {
    margin-bottom: 10px;
  }
`;
